export type Tone = 'neutral' | 'ok' | 'warn' | 'danger' | 'info' | 'accent' | 'reserve'

/**
 * Status words used across F4/F5 (lots, sessions, payouts, exceptions, outbox) mapped to tones.
 * Add new statuses here so every screen colours them the same way.
 */
export const STATUS_TONES: Record<string, Tone> = {
  OK: 'ok',
  OPEN: 'info',
  ACTIVE: 'ok',
  APPLIED: 'ok',
  DUPLICATE: 'ok',
  PAID: 'ok',
  COMMITTED: 'ok',
  RECEIVED: 'ok',
  RESOLVED: 'ok',
  CLOSED: 'neutral',
  DRAFT: 'neutral',
  PENDING: 'neutral',
  SENDING: 'info',
  ISSUED: 'info',
  LOADING: 'info',
  IN_TRANSIT: 'info',
  PENDING_APPROVAL: 'warn',
  WAIT_FOR_PARENT: 'warn',
  HOLD: 'warn',
  HELD: 'warn',
  RECEIVED_SHORT: 'warn',
  WAIVED: 'reserve',
  ORDINARY: 'reserve',
  VOID: 'danger',
  ERROR: 'danger',
  FAILED: 'danger',
  REVERSED: 'danger',
  RETURNED: 'danger',
  REVOKED: 'danger',
  CRITICAL: 'danger',
  HIGH: 'danger',
  MEDIUM: 'warn',
  LOW: 'neutral',
  RUNNING: 'info',
  BALANCED: 'ok',
  EXCEPTION: 'warn',
  CANCELLED: 'neutral',
  PACKING: 'info',
  RELEASED: 'ok',
  RECALLED: 'danger',
  WITHDRAWN: 'danger',
  DESTROYED: 'danger',
  APPROVED: 'ok',
  RETIRED: 'neutral',
  ENTERED: 'warn',
  VERIFIED: 'ok',
  REJECTED: 'danger',
  PASS: 'ok',
  FAIL: 'danger',
  INCOMPLETE: 'warn',
  NOT_ACCEPTED: 'danger',
  NOT_DETECTED: 'ok',
  WITHIN_LIMIT: 'ok',
  DETECTED: 'danger',
  OVER_LIMIT: 'danger',
  LOQ_TOO_HIGH: 'warn',
  QUARANTINE: 'warn',
  WAITING: 'info',
}
